"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dictionary = void 0;
/**
 * A record containing all texts used in the components.
 * The values can be overwritten to support internationalization.
 */
exports.dictionary = {
    literals: {
        ascending: 'Ascending',
        cancel: 'Cancel',
        confirm: 'Confirm',
        delete: 'Delete',
        descending: 'Descending',
        next: 'Next',
        previous: 'Previous',
        save: 'Save',
        search: 'Search',
        sort: 'Sort',
        enterASearchQueryForMoreSpecificResults: 'Enter a search query for more specific results',
    },
    dynamics: {
        showingXToYOfZResults: (from, to, total) => `Showing ${from !== null && from !== void 0 ? from : '-'} to ${to !== null && to !== void 0 ? to : '-'} of ${total !== null && total !== void 0 ? total : '-'} results`,
    },
};
